import { render, staticRenderFns } from "./ReserveChange.vue?vue&type=template&id=25a5796b&scoped=true"
import script from "./ReserveChange.vue?vue&type=script&lang=js"
export * from "./ReserveChange.vue?vue&type=script&lang=js"
import style0 from "./ReserveChange.vue?vue&type=style&index=0&id=25a5796b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a5796b",
  null
  
)

export default component.exports